<template>
  <div>
    <h3>{{dtext[0]}}</h3>
    <hr>
    <div class="title">1. Access</div>
    <div class="description">Once you get access to the ADMIN Dashboard, the setup procedure is very easy.</div>
    <div class="description">UpayS offers 2 types of payment plans - free/trial and paid (silver/gold)</div>
    <div class="title">2. Let's see what the ADMIN Dashboard looks like </div>
    <img class="small_image" src="../assets/client-dashboard.png" alt="dashboard details">
    <div class="title">2. How to set up the Payment Page for your business?</div>
    <div class="description"> Your business has the possibility to select from 2 models : B2B (business to business) or B2C (business to client)  </div>
    <div class="description">B2B has 2 fields displayed on the payment page - 'Registration number.' and 'VAT Id.', as these are data related to a type of business customer</div>
    <div class="title">3. How to set the type of payment - 'monthly fee' or 'one single fee' ?</div>
    <div class="description">Your business can choose between one single payment fee or a monthly payment fee choosing this option when configure the payment page.<br>One payment fee disabled the incremented field of number of months</div>
    <div class="title">4. How to preview your configured Payment Page?</div>
    <div class="description"> It's very simple - use the 'Preview' button</div>
    <br>
    <img class="medium_image" src="../../src/assets/upays_screen_0_1.png" alt="payment_page">
    <div class="title">5.Update/Create clients on STRIPE platform</div>
    <div class="description"> Each completed payment (if this means a new customer for your business) could generate an entity/customer in your STRIPE account</div>
    <div class="description"> So the only thing left to do is to set on the checkbox concerning Stripe clients - option available within ADMIN Dashboard</div>
    <div class="title">6. UpayS generates SHA256 keys for your business customers</div>
    <div class="description"> If your business needs an authentication process, UpayS can help you generate unique KEYS for your customers</div>
    <div class="description">So the only thing left to do is to set on the checkbox named 'Generate SHA256' - option available within ADMIN Dashboard</div>
    <div class="description">To view and download all the keys for customers you have to use the 'View/Display' button. Next image show the result</div>
    <img class="small_image" src="../../src/assets/upays-keys.png" alt="keys_page">
    <div class="title">7. How could your business to use the STRIPE payment service through the UpayS service?</div>
    <div class="description">UpayS will generate a payment link called PAYLink.<br>The generating procedure is activated immediately after entering your business link(redirect link)<br>
      Next step is to use this PAYLink in your business application.(e.g. attach the link to a pay button )</div>
    <img class="small_image" src="../../src/assets/1_upays-glink.png" alt="paylink">
  </div>
</template>
<script>
import {getDocsText} from "@/translate";

export default {
  name: 'Dashboard',
  data() {
    return {
      dtext:''
    }
  },
  mounted() {
    this.dtext = getDocsText(0)
    this.emitter.emit('heroku', {'eventContent': '1'})
  }
}
</script>
<style>
 .medium_image {
   width: 50%;
   height: 50%;
   background-color: black;
 }
 .small_image {
   width: 30%;
   height: 30%;
 }
 .description {
   font-size: 18px;
   font-family: "Apple Symbols",fantasy;
 }
 .title {
   font-weight: bold;
   color: crimson;
   margin-top: 10px;
   margin-bottom: 15px;
 }
 @media (max-width: 400px) {
   .title {
     font-size: 11px;
   }
   h3 {
     font-size: 13px;
   }
   .description {
     font-size: 11px;
   }

 }
</style>